import type { ReactElement } from "react";
import { Button } from "../../ui/Button/Button";
import { Alert } from "../../ui/Alert/Alert";
import { Brand, PfMark } from "../../shell/Brand";
import styles from "./SignInCard.module.css";

export interface SignInCardProps {
  onSignIn: () => void;
  error?: string;
}

export function SignInCard({ onSignIn, error }: SignInCardProps): ReactElement {
  return (
    <div className={styles.card}>
      <Brand size={24} className={styles.logo} />

      {error ? (
        <div className={styles.error}>
          <Alert tone="danger" title="We could not complete your sign-in">
            {error}
          </Alert>
        </div>
      ) : null}

      <h1 className={styles.title}>Sign in to the Developer Network</h1>
      <p className={styles.intro}>
        Use the Property Finder account you already have.
      </p>

      <Button
        variant="primary"
        size="md"
        fullWidth
        iconLeft={<PfMark size={18} />}
        onClick={onSignIn}
      >
        Continue with Property Finder
      </Button>

      <p className={styles.hint}>
        You&rsquo;ll be redirected to Property Finder to authorise access, then
        returned to <strong>/app</strong>.
      </p>
    </div>
  );
}
